import { rem } from 'polished';
import styled from 'styled-components';
import { sidePaddingStyles } from '../../common/padding.styles';

export const StyledPageNotFound = styled.div`
  padding-top: ${rem(32)};
  ${sidePaddingStyles}
`;
